/* ------------------------------------------------------------
   FC COLLECTION SHOWCASE
   Extracted from the inline <script> in
   sections/fighters-collection-showcase.liquid.

   Two reasons: an inline script is parser-blocking and cannot be
   cached between page views, and pulling it out keeps the section
   file small enough to edit safely. Loaded with defer.
   ------------------------------------------------------------ */
(function () {
  function initShowcase(root) {
    if (!root || root.dataset.fcInit === 'true') return;
    root.dataset.fcInit = 'true';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion && 'IntersectionObserver' in window) {
      root.classList.add('fc-showcase--reveal-ready');
      var handoffObserver = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          var hero = document.querySelector('.fc-video-hero');
          if (hero) hero.classList.add('fc-video-hero--handoff-active');
          window.requestAnimationFrame(function () {
            root.classList.add('fc-showcase--handoff-visible');
          });
          handoffObserver.disconnect();
        },
        { threshold: 0.08, rootMargin: '0px 0px -8% 0px' }
      );
      handoffObserver.observe(root);
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.fc-panel'));

    function activate(index, setFocus) {
      if (index < 0 || index >= tabs.length) return;
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      if (setFocus && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i, false);
      });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          event.preventDefault();
          activate(next, true);
        }
      });
    });

    root.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-fc-quick-add]') : null;
      if (!button) return;
      event.preventDefault();

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      button.setAttribute('aria-busy', 'true');

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          button.classList.add('is-added');
          setTimeout(function () {
            button.classList.remove('is-added');
          }, 1400);
          refreshCart();
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .then(function () {
          button.removeAttribute('aria-busy');
        });
    });

    function refreshCart() {
      var drawer = document.querySelector('cart-drawer');
      var bubble = document.getElementById('cart-icon-bubble');
      var wanted = [];
      if (drawer) wanted.push('cart-drawer');
      if (bubble) wanted.push('cart-icon-bubble');
      if (!wanted.length) return;

      fetch('/?sections=' + wanted.join(','))
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (bubble && data['cart-icon-bubble']) {
            var wrapper = document.createElement('div');
            wrapper.innerHTML = data['cart-icon-bubble'];
            var fresh = wrapper.querySelector('#cart-icon-bubble') || wrapper.firstElementChild;
            if (fresh) bubble.innerHTML = fresh.innerHTML;
          }
          if (drawer && data['cart-drawer']) {
            var dw = document.createElement('div');
            dw.innerHTML = data['cart-drawer'];
            var freshDrawer = dw.querySelector('cart-drawer');
            if (freshDrawer) {
              drawer.innerHTML = freshDrawer.innerHTML;
              drawer.classList.remove('is-empty');
              if (typeof drawer.open === 'function') drawer.open();
            }
          }
        })
        .catch(function () {});
    }
  }

  function initAll() {
    document.querySelectorAll('[data-fc-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fc-showcase]');
    if (root) initShowcase(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (!el || !el.closest) return;
    var root = el.closest('[data-fc-showcase]');
    if (!root) return;
    var tabButton = null;
    if (el.classList.contains('fc-tab')) {
      tabButton = el;
    } else if (el.classList.contains('fc-panel')) {
      tabButton = root.querySelector('[aria-controls="' + el.id + '"]');
    }
    if (tabButton) tabButton.click();
  });
})();
